import { makeStyles } from '@material-ui/core';
import React from 'react';
import ReactMarkdown from 'react-markdown';
import clsx from 'clsx';

const useStyles = makeStyles(
  () => ({
    container: {
      fontFamily: 'Inter',
      '& h1': {
        fontSize: '36px',
        lineHeight: '42px',
        fontWeight: 400,
      },
      '& h2': {
        fontSize: '28px',
        lineHeight: '36px',
        fontWeight: 400,
      },
      '& h3': {
        fontSize: '24px',
        lineHeight: '28px',
        fontWeight: 400,
      },
      '& h4': {
        fontSize: '20px',
        lineHeight: '26px',
        fontWeight: 400,
      },
      '& h5': {
        fontSize: '18px',
        lineHeight: '24px',
        fontWeight: 400,
      },
      '& h6': {
        fontSize: '16px',
        lineHeight: '24px',
        fontWeight: 600,
      },
      '& p, & li': {
        lineHeight: '24px',
      },
    },
  }),
  {
    name: 'MarkdownText',
  }
);

interface MarkdownTextProps {
  text?: string;
  className?: string;
}

const MarkdownText = ({ text, className }: MarkdownTextProps) => {
  const classes = useStyles();

  if (!text) {
    return null;
  }

  return <ReactMarkdown className={clsx(classes.container, className)}>{text}</ReactMarkdown>;
};

export default MarkdownText;
